<h1>Daily Production Form</h1>

<p *ngIf="shiftClosed">
  <p-message closable="false" severity="warn" text="Daily Production is not editable because the shift is closed."></p-message>
</p>

<p-tabMenu [activeItem]="activeItem" [model]="items">
  <ng-template let-i="index" let-item pTemplate="item">
    <div style="position: relative; text-align: center; min-width: 10em">
      <div class="ui-menuitem-text">
        {{item.label}}
      </div>
    </div>
  </ng-template>
</p-tabMenu>
<div *ngIf="items else noItems">
  <div *ngIf="!!invCount else noCount">
    <div [ngSwitch]="currentSubinventoryType">
      <div *ngSwitchCase="SubinventoryType.ChepPlantPallets">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 p-sm bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              inventoryType="production">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-6 p-xl-5 lineTable">
            <app-sort-line-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-sort-line-inventory>
          </div>
          <div class="p-col-12 p-md-6 p-xl-5 lineTable">
            <app-repair-line-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="rliChild ml">
            </app-repair-line-inventory>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <app-teardowns-scrap
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-teardowns-scrap>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-8 p-xl-6">
            <app-chep-misc-info
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-chep-misc-info>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.ChepComponents">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 compTable">
            <app-components-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-components-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]="shiftClosed"
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-10 p-xl-8 supplyTable">
            <app-supplies-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-supplies-inventory>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.TpmProduction">
        <div class="p-grid">
          <div class="p-col-12">
            <app-tpm-trailer-summary
              class="rliChild">
            </app-tpm-trailer-summary>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col p-lg-10 p-xl-8">
            <app-tpm-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-tpm-inventory>
          </div>
          <div class="p-col p-lg-10 p-xl-8 wmMiscInfo">
            <app-walmart-misc-info
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="rliChild">
            </app-walmart-misc-info>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.WhiteWoodComponents">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 compTable">
            <app-components-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-components-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col p-md-8 p-lg-6 p-xl-6 supplyTable">
            <app-supplies-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-supplies-inventory>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.ChepPalletStorage">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.VendorOnPremise">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.AssetRecovery">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.PecoPallets">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.PecoComponents">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 compTable">
            <app-components-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-components-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-10 p-xl-8 supplyTable">
            <app-supplies-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-supplies-inventory>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.IgpsPallets">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-4 p-xl-3">
            <app-igps-misc-info
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild">
            </app-igps-misc-info>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.UsedAssetCenter">
        <div class="p-grid">
          <div class="p-col-12 p-lg-8">
            <app-uac-misc-info
              [subinventoryId]="invCount.siteSubinventoryId"
              [invCountId]="invCount.id"
              class="sliChild">
            </app-uac-misc-info>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="SubinventoryType.Rm2Pallets">
        <div class="p-grid p-flex-wrap-reverse">
          <div class="p-col p-xl-10 bayTable">
            <app-bay-inventory
              [invCountId]="invCount.id"
              [subinventoryId]="invCount.siteSubinventoryId"
              class="sliChild"
              inventoryType="storage">
            </app-bay-inventory>
          </div>
          <div class="p-col p-sm-pull-2">
            <p-button
              (onClick)="CopyPreviousShift(invCount.siteSubinventoryId)"
              [disabled]=shiftClosed
              icon="pi pi-copy"
              iconPos="left"
              label="Copy Previous Shift">
            </p-button>
          </div>
        </div>
      </div>
      <div *ngSwitchDefault>
        <p>Unknown subinventory type.</p>
      </div>
    </div>
  </div>
  <ng-template #noCount>
    <p>This inventory was not configured on this shift.</p>
  </ng-template>
</div>
<ng-template #noItems>
  <p-card>
    <p>Cannot display inventories.</p>
  </p-card>
</ng-template>
